import React, { useEffect, useState } from 'react';
import axios from 'axios';

function DebugJobsJSON() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [jobsRes, candidatesRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_DOMAINE}/api/jobs`),
          axios.get(`${process.env.REACT_APP_DOMAINE}/api/candidates`)
        ]);
        setData({
          jobs: jobsRes.data,
          candidates: candidatesRes.data
        });
      } catch (err) {
        console.error("Error fetching data:", err.message);
      }
    };

    fetchData();
  }, []);

  if (!data) return null;

  return (
    <pre style={{ margin: 0, padding: 0, fontFamily: 'monospace', fontSize: '12px' }}>
      {JSON.stringify(data, null, 2)}
    </pre>
  );
}

export default DebugJobsJSON;
